import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";
import Colors from "../../Colors";

export const HitParticle = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: Colors.GRAY_3,
  bg: null,
  animate: async (particle: Particle<{ fg: string | null }>) => {
    await awaitAnimate({
      driver: particle.driver,
      from: particle.options?.fg,
      to: Colors.DEEP_RED,
      duration: 200,
      onUpdate: (latest) => {
        particle.fg = latest;
      },
    });

    await new Promise((r) => {
      window.setTimeout(r, 25);
    });

    await awaitAnimate({
      driver: particle.driver,
      from: Colors.DEEP_RED,
      to: Colors.OFF_BLACK,
      duration: 50,
      onUpdate: (latest) => {
        particle.fg = latest;
      },
    });
  },
};
